export const TOUCHPOINT_WEB_APP_CMD = 'WEB_APP_CMD';
